import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.categories": "Categories",
      "nav.myAds": "My Ads",
      "nav.favorites": "Favorites",
      "nav.messages": "Messages",
      "nav.chats": "Chats",
      "nav.login": "Login",
      "nav.register": "Register",
      "nav.postAd": "Post Your Ad",
      "nav.placeAd": "Place an ad",
      "nav.logout": "Logout",
      "nav.profile": "Profile",
      "nav.menu": "Menu",
      "nav.search": "Search",
      
      // Homepage
      "home.searchPlaceholder": "Search for",
      "home.property": "property",
      "home.cars": "cars",
      "home.jobs": "jobs",
      "home.furniture": "furniture",
      "home.phones": "phones",
      "home.whatsNew": "What's new on Findadz",
      "home.verificationTitle": "Got a verified badge yet?",
      "home.verificationDesc1": "Get more visibility",
      "home.verificationDesc2": "Enhance your credibility",
      
      // Categories
      "category.propertyRent": "Property for Rent",
      "category.propertySale": "Property for Sale",
      "category.offPlan": "Off-Plan Properties",
      "category.rooms": "Rooms for Rent",
      "category.motors": "Motors",
      "category.jobs": "Jobs",
      "category.classifieds": "Classifieds",
      "category.furniture": "Furniture & Garden",
      "category.community": "Community",
      "category.electronics": "Electronics",
      "category.fashion": "Fashion",
      "category.babyKids": "Baby & Kids",
      "category.hobbiesSports": "Hobbies & Sports",
      "category.pets": "Pets",
      "category.services": "Services",
      
      // Listings
      "listing.featured": "FEATURED",
      "listing.boosted": "BOOSTED",
      "listing.new": "New",
      "listing.used": "Used",
      "listing.viewDetails": "View Details",
      "listing.contactSeller": "Contact Seller",
      "listing.saveAd": "Save Ad",
      "listing.saved": "Saved",
      "listing.reportAd": "Report Ad",
      "listing.share": "Share",
      "listing.description": "Description",
      "listing.details": "Details",
      "listing.price": "Price",
      "listing.location": "Location",
      "listing.posted": "Posted",
      "listing.views": "views",
      "listing.condition": "Condition",
      "listing.seller": "Seller",
      "listing.memberSince": "Member since",
      "listing.call": "Call",
      "listing.chat": "Chat",
      "listing.whatsapp": "WhatsApp",
      "listing.safetyTips": "Safety Tips",
      "listing.safetyTip1": "Meet in a public place",
      "listing.safetyTip2": "Check the item before you buy",
      "listing.safetyTip3": "Pay only after inspecting the item",
      "listing.relatedListings": "Related Listings",
      "listing.noListings": "No listings found",
      "listing.edit": "Edit",
      "listing.delete": "Delete",
      "listing.deleteConfirm": "Are you sure you want to delete this listing?",
      
      // Post Ad
      "postAd.title": "Place an Ad",
      "postAd.stepCategory": "Select Category",
      "postAd.stepDetails": "Ad Details",
      "postAd.stepPhotos": "Add Photos",
      "postAd.stepReview": "Review Your Ad",
      "postAd.stepUpgrade": "Boost Your Ad",
      "postAd.adTitle": "Title",
      "postAd.titlePlaceholder": "What are you selling?",
      "postAd.description": "Description",
      "postAd.descPlaceholder": "Describe your item in detail...",
      "postAd.price": "Price (AED)",
      "postAd.location": "Location",
      "postAd.selectLocation": "Select",
      "postAd.condition": "Condition",
      "postAd.phone": "Your Phone",
      "postAd.phonePlaceholder": "+971 50 123 4567",
      "postAd.whatsapp": "WhatsApp",
      "postAd.uploadPhotos": "Add Photo",
      "postAd.photoTip": "Tip: Good photos increase your chances of selling",
      "postAd.coverPhoto": "Cover",
      "postAd.maxPhotos": "Add up to 6 photos. First photo will be the cover.",
      "postAd.publish": "Post Ad",
      "postAd.publishAd": "Post Ad",
      "postAd.payAndPost": "Pay & Post",
      "postAd.posting": "Posting...",
      "postAd.uploadingPhotos": "Uploading Photos",
      "postAd.next": "Continue",
      "postAd.continue": "Continue",
      "postAd.back": "Back",
      "postAd.subcategory": "Subcategory",
      "postAd.selectSubcategory": "Select Subcategory",
      "postAd.sellerName": "Your Name",
      "postAd.boostAd": "Boost Your Ad",
      "postAd.boostDesc": "Get more visibility and sell faster",
      "postAd.featured": "Featured",
      "postAd.boosted": "Boosted",
      "postAd.days": "days",
      "postAd.selected": "Selected",
      "postAd.noThanks": "No thanks, post for free",
      "postAd.untitled": "Untitled",
      "postAd.noDescription": "No description",
      
      // Upgrade Options
      "upgrade.title": "Boost Your Ad",
      "upgrade.subtitle": "Get more visibility and sell faster",
      "upgrade.featured": "Featured",
      "upgrade.featuredDesc": "Appear on homepage and top of category",
      "upgrade.boost": "Boost",
      "upgrade.boostDesc": "Top of search results",
      "upgrade.noUpgrade": "No thanks, post for free",
      "upgrade.selected": "Selected",
      "upgrade.payNow": "Pay Now",
      "upgrade.duration": "Duration",
      "upgrade.days": "days",
      
      // Auth
      "auth.welcomeBack": "Welcome Back",
      "auth.loginSubtitle": "Login to your Findadz account",
      "auth.createAccount": "Create Account",
      "auth.registerSubtitle": "Join Findadz today",
      "auth.login": "Login",
      "auth.register": "Register",
      "auth.email": "Email",
      "auth.emailPlaceholder": "your@email.com",
      "auth.password": "Password",
      "auth.fullName": "Full Name",
      "auth.fullNamePlaceholder": "John Doe",
      "auth.phone": "Phone (Optional)",
      "auth.phoneRequired": "Phone Number",
      "auth.phoneChangeNote": "You can change the country code if needed",
      "auth.whatsapp": "WhatsApp (Optional)",
      "auth.whatsappPlaceholder": "Same as phone or different",
      "auth.loginButton": "Login",
      "auth.registerButton": "Create Account",
      "auth.noAccount": "Don't have an account?",
      "auth.haveAccount": "Already have an account?",
      "auth.loading": "Loading...",
      "auth.error": "An error occurred. Please try again.",
      
      // Favorites
      "favorites.title": "All Favorites",
      "favorites.default": "Default",
      "favorites.savedAds": "saved ads",
      "favorites.empty": "No saved ads yet",
      "favorites.browse": "Browse Listings",
      "favorites.personalizedTitle": "Personalized Favorite lists",
      "favorites.createList": "Create your personalized list",
      "favorites.organizeDesc": "Organize your favorites",
      "favorites.inviteDesc": "Invite friends to view or collaborate on your list",
      "favorites.makeList": "Make A List",
      
      // Dashboard
      "dashboard.myAds": "My Ads",
      "dashboard.favorites": "Favorites",
      "dashboard.messages": "Messages",
      "dashboard.profileDesc": "Update your public profile information",
      "dashboard.settingsDesc": "Manage your account preferences and privacy",
      
      // Settings
      "settings.emailNotifications": "Email Notifications",
      "settings.pushNotifications": "Push Notifications",
      "settings.smsNotifications": "SMS Notifications",
      "settings.privacy": "Privacy",
      "settings.showPhone": "Show phone number on listings",
      "settings.showWhatsapp": "Show WhatsApp on listings",
      "settings.changePassword": "Change Password",
      "settings.saveSettings": "Save Settings",
      
      // Chats
      "chats.title": "Chats",
      "chats.select": "Select",
      "chats.all": "All",
      "chats.buying": "Buying",
      "chats.selling": "Selling",
      "chats.unread": "Unread",
      "chats.verified": "Are you verified?",
      "chats.verifiedDesc": "Get more visibility and enhance your credibility.",
      "chats.deactivated": "Deactivated Chats",
      "chats.empty": "Your chat is empty!",
      "chats.emptyDesc": "Post an ad or message a seller to start seeing conversations here",
      "chats.explore": "Explore",
      "chats.postAd": "Post an Ad",
      "chats.noMessages": "No messages yet",
      "chats.typeMessage": "Type a message...",
      "chats.send": "Send",
      "chats.startConversation": "Start the conversation!",
      
      // Menu
      "menu.getVerified": "Get Verified",
      "menu.joined": "Joined on",
      "menu.loginRegister": "Login / Register",
      "menu.myAds": "My Ads",
      "menu.mySearches": "My Searches",
      "menu.profile": "Profile",
      "menu.accountSettings": "Account Settings",
      "menu.notificationSettings": "Notification Settings",
      "menu.security": "Security",
      "menu.jobApplications": "My Job Applications",
      "menu.carAppointments": "Car Appointments",
      "menu.carInspections": "Car Inspections",
      "menu.city": "City",
      "menu.allCities": "All Cities",
      "menu.language": "Language",
      "menu.english": "English",
      "menu.arabic": "العربية",
      "menu.blogs": "Blogs",
      "menu.support": "Support",
      "menu.callUs": "Call Us",
      "menu.legalHub": "Legal Hub",
      "menu.termsOfService": "Terms of Service",
      "menu.privacyPolicy": "Privacy Policy",
      "menu.postingRules": "Posting Rules",
      "menu.safetyTips": "Safety Tips",
      "menu.advertising": "Advertising",
      "menu.logout": "Log Out",
      "menu.version": "v1.0.0",
      
      // Admin
      "admin.title": "Admin Panel",
      "admin.dashboard": "Dashboard",
      "admin.listings": "Listings",
      "admin.users": "Users",
      "admin.totalUsers": "Total Users",
      "admin.totalListings": "Total Listings",
      "admin.activeListings": "Active Listings",
      "admin.pendingReview": "Pending Review",
      "admin.totalRevenue": "Total Revenue",
      "admin.todayActivity": "Today's Activity",
      "admin.newUsers": "New Users",
      "admin.newListings": "New Listings",
      "admin.approve": "Approve",
      "admin.reject": "Reject",
      "admin.delete": "Delete",
      "admin.makeAdmin": "Make Admin",
      "admin.removeAdmin": "Remove Admin",
      "admin.admin": "Admin",
      "admin.noListings": "No listings found",
      "admin.noUsers": "No users found",
      "admin.noName": "No name",
      "admin.accessRequired": "Admin Access Required",
      "admin.noPermission": "You don't have permission to access this page.",
      "admin.goHome": "Go Home",
      "admin.confirmDelete": "Are you sure you want to delete this listing?",
      "admin.statusFailed": "Failed to update status",
      "admin.deleteFailed": "Failed to delete listing",
      "admin.toggleAdminFailed": "Failed to toggle admin",
      "admin.active": "Active",
      "admin.pending": "Pending",
      "admin.sold": "Sold",
      "admin.rejected": "Rejected",
      "admin.flagged": "Flagged",
      "admin.analytics": "Analytics",
      
      // Dashboard
      "dashboard.welcome": "Welcome back",
      "dashboard.manage": "Manage your listings and account",
      "dashboard.postNew": "Post New Ad",
      "dashboard.totalAds": "Total Ads",
      "dashboard.totalViews": "Total Views",
      "dashboard.favorites": "Favorites",
      "dashboard.messages": "Messages",
      "dashboard.noAds": "No ads posted yet",
      "dashboard.postFirst": "Post Your First Ad",
      "dashboard.noFavorites": "No favorites yet",
      "dashboard.comingSoon": "Coming soon - Real-time messaging system",
      "dashboard.saveChanges": "Save Changes",
      "dashboard.saving": "Saving...",
      "dashboard.profileUpdated": "Profile updated successfully!",
      
      // Edit Listing
      "edit.title": "Edit Listing",
      "edit.photos": "Photos",
      "edit.details": "Details",
      "edit.contactInfo": "Contact Info",
      "edit.saveChanges": "Save Changes",
      "edit.saving": "Saving...",
      "edit.uploadingPhotos": "Uploading Photos...",
      "edit.newPhoto": "New",
      
      // Filters
      "filter.title": "Filters",
      "filter.filters": "Filters",
      "filter.all": "All",
      "filter.location": "Location",
      "filter.category": "Category",
      "filter.price": "Price",
      "filter.priceMin": "Min Price",
      "filter.priceMax": "Max Price",
      "filter.min": "Min",
      "filter.max": "Max",
      "filter.condition": "Condition",
      "filter.apply": "Apply Filters",
      "filter.clear": "Clear",
      "filter.clearFilters": "Clear Filters",
      "filter.reset": "Reset",
      "filter.results": "results",
      "filter.sortBy": "Sort by",
      "filter.newest": "Newest First",
      "filter.oldest": "Oldest First",
      "filter.priceLow": "Price: Low to High",
      "filter.priceHigh": "Price: High to Low",
      
      // Search
      "search.resultsFor": "Results for",
      "search.allListings": "All Listings",
      "search.adsFound": "ads found",
      "search.noResults": "No listings found",
      
      // Notifications
      "notifications.title": "Notifications",
      "notifications.markAllRead": "Mark all as read",
      "notifications.empty": "No notifications",
      "notifications.emptyDesc": "You're all caught up!",
      "notifications.newMessage": "New message",
      "notifications.newFavorite": "saved your listing",
      "notifications.listingApproved": "Your listing has been approved",
      "notifications.listingRejected": "Your listing has been rejected",
      "notifications.priceAlert": "Price drop on a saved item",
      "notifications.viewAll": "View All",
      "notifications.enablePush": "Enable Push Notifications",
      "notifications.pushEnabled": "Push notifications enabled",
      "notifications.pushBlocked": "Push notifications blocked",
      
      // Common
      "common.aed": "AED",
      "common.loading": "Loading...",
      "common.save": "Save Changes",
      "common.saving": "Saving...",
      "common.saved": "Settings saved!",
      "common.cancel": "Cancel",
      "common.search": "Search",
      "common.viewAll": "View All",
      "common.contact": "Contact",
      "common.message": "Message",
      "common.copy": "Copy Link",
      "common.copied": "Link copied!",
      "common.error": "Error",
      "common.success": "Success",
      "common.confirm": "Confirm",
      "common.yes": "Yes",
      "common.no": "No",
      "common.ok": "OK",
      "common.back": "Back",
      "common.next": "Next",
      "common.submit": "Submit",
      "common.required": "Required",
      "common.optional": "Optional",
      "common.select": "Select",
      "common.aed": "AED",
      "common.guest": "Guest",
      "common.noResults": "No results found",
      "common.tryAgain": "Try again",
      "common.guest": "Guest",
      
      // Errors
      "error.generic": "Something went wrong. Please try again.",
      "error.network": "Network error. Please check your connection.",
      "error.unauthorized": "Please login to continue.",
      "error.notFound": "Not found",
      "error.invalidCredentials": "Invalid email or password",
      "error.emailExists": "Email already registered",
      "error.requiredFields": "Please fill required fields",
      "error.selectCategory": "Please select a category",
      "error.uploadFailed": "Failed to upload image",
      "error.deleteFailed": "Failed to delete",
      "error.updateFailed": "Failed to update",
      
      // Success Messages
      "success.adPosted": "Ad posted successfully!",
      "success.adUpdated": "Ad updated successfully!",
      "success.adDeleted": "Ad deleted successfully!",
      "success.profileUpdated": "Profile updated successfully!",
      "success.messageSent": "Message sent!",
      "success.addedToFavorites": "Added to favorites",
      "success.removedFromFavorites": "Removed from favorites",
      
      // UAE Locations
      "location.dubai": "Dubai",
      "location.abuDhabi": "Abu Dhabi",
      "location.sharjah": "Sharjah",
      "location.ajman": "Ajman",
      "location.rasAlKhaimah": "Ras Al Khaimah",
      "location.fujairah": "Fujairah",
      "location.ummAlQuwain": "Umm Al Quwain",
      "location.alAin": "Al Ain",
    }
  },
  ar: {
    translation: {
      // Navigation
      "nav.home": "الرئيسية",
      "nav.categories": "الفئات",
      "nav.myAds": "إعلاناتي",
      "nav.favorites": "المفضلة",
      "nav.messages": "الرسائل",
      "nav.chats": "المحادثات",
      "nav.login": "تسجيل الدخول",
      "nav.register": "إنشاء حساب",
      "nav.postAd": "أضف إعلانك",
      "nav.placeAd": "أضف إعلان",
      "nav.logout": "تسجيل الخروج",
      "nav.profile": "الملف الشخصي",
      "nav.menu": "القائمة",
      "nav.search": "بحث",
      
      // Homepage
      "home.searchPlaceholder": "ابحث عن",
      "home.property": "عقارات",
      "home.cars": "سيارات",
      "home.jobs": "وظائف",
      "home.furniture": "أثاث",
      "home.phones": "هواتف",
      "home.whatsNew": "الجديد في فايند أدز",
      "home.verificationTitle": "هل حصلت على شارة التحقق؟",
      "home.verificationDesc1": "احصل على مزيد من الظهور",
      "home.verificationDesc2": "عزز مصداقيتك",
      
      // Categories
      "category.propertyRent": "عقارات للإيجار",
      "category.propertySale": "عقارات للبيع",
      "category.offPlan": "عقارات على الخارطة",
      "category.rooms": "غرف للإيجار",
      "category.motors": "سيارات",
      "category.jobs": "وظائف",
      "category.classifieds": "إعلانات مبوبة",
      "category.furniture": "أثاث وحدائق",
      "category.community": "مجتمع",
      "category.electronics": "إلكترونيات",
      "category.fashion": "أزياء",
      "category.babyKids": "أطفال ورضع",
      "category.hobbiesSports": "هوايات ورياضة",
      "category.pets": "حيوانات أليفة",
      "category.services": "خدمات",
      
      // Listings
      "listing.featured": "مميز",
      "listing.boosted": "معزز",
      "listing.new": "جديد",
      "listing.used": "مستعمل",
      "listing.viewDetails": "عرض التفاصيل",
      "listing.contactSeller": "اتصل بالبائع",
      "listing.saveAd": "حفظ الإعلان",
      "listing.saved": "محفوظ",
      "listing.reportAd": "إبلاغ عن الإعلان",
      "listing.share": "مشاركة",
      "listing.description": "الوصف",
      "listing.details": "التفاصيل",
      "listing.price": "السعر",
      "listing.location": "الموقع",
      "listing.posted": "تاريخ النشر",
      "listing.views": "مشاهدة",
      "listing.condition": "الحالة",
      "listing.seller": "البائع",
      "listing.memberSince": "عضو منذ",
      "listing.call": "اتصال",
      "listing.chat": "محادثة",
      "listing.whatsapp": "واتساب",
      "listing.safetyTips": "نصائح السلامة",
      "listing.safetyTip1": "قابل في مكان عام",
      "listing.safetyTip2": "افحص المنتج قبل الشراء",
      "listing.safetyTip3": "ادفع فقط بعد فحص المنتج",
      "listing.relatedListings": "إعلانات ذات صلة",
      "listing.noListings": "لا توجد إعلانات",
      "listing.edit": "تعديل",
      "listing.delete": "حذف",
      "listing.deleteConfirm": "هل أنت متأكد من حذف هذا الإعلان؟",
      
      // Post Ad
      "postAd.title": "أضف إعلان",
      "postAd.stepCategory": "اختر الفئة",
      "postAd.stepDetails": "تفاصيل الإعلان",
      "postAd.stepPhotos": "إضافة صور",
      "postAd.stepReview": "راجع إعلانك",
      "postAd.stepUpgrade": "عزز إعلانك",
      "postAd.adTitle": "العنوان",
      "postAd.titlePlaceholder": "ماذا تبيع؟",
      "postAd.description": "الوصف",
      "postAd.descPlaceholder": "صف منتجك بالتفصيل...",
      "postAd.price": "السعر (درهم)",
      "postAd.location": "الموقع",
      "postAd.selectLocation": "اختر",
      "postAd.condition": "الحالة",
      "postAd.phone": "رقم الهاتف",
      "postAd.phonePlaceholder": "+971 50 123 4567",
      "postAd.whatsapp": "واتساب",
      "postAd.uploadPhotos": "إضافة صورة",
      "postAd.photoTip": "نصيحة: الصور الجيدة تزيد فرص البيع",
      "postAd.coverPhoto": "غلاف",
      "postAd.maxPhotos": "أضف حتى 6 صور. الصورة الأولى ستكون الغلاف.",
      "postAd.publish": "نشر الإعلان",
      "postAd.publishAd": "نشر الإعلان",
      "postAd.payAndPost": "ادفع وانشر",
      "postAd.posting": "جاري النشر...",
      "postAd.uploadingPhotos": "جاري رفع الصور",
      "postAd.next": "التالي",
      "postAd.continue": "التالي",
      "postAd.back": "رجوع",
      "postAd.subcategory": "الفئة الفرعية",
      "postAd.selectSubcategory": "اختر الفئة الفرعية",
      "postAd.sellerName": "اسمك",
      "postAd.boostAd": "عزز إعلانك",
      "postAd.boostDesc": "احصل على مزيد من الظهور وبيع أسرع",
      "postAd.featured": "مميز",
      "postAd.boosted": "معزز",
      "postAd.days": "أيام",
      "postAd.selected": "مختار",
      "postAd.noThanks": "لا شكراً، انشر مجاناً",
      "postAd.untitled": "بدون عنوان",
      "postAd.noDescription": "بدون وصف",
      
      // Upgrade Options
      "upgrade.title": "عزز إعلانك",
      "upgrade.subtitle": "احصل على مزيد من الظهور وبيع أسرع",
      "upgrade.featured": "مميز",
      "upgrade.featuredDesc": "يظهر في الصفحة الرئيسية وأعلى الفئة",
      "upgrade.boost": "تعزيز",
      "upgrade.boostDesc": "أعلى نتائج البحث",
      "upgrade.noUpgrade": "لا شكراً، انشر مجاناً",
      "upgrade.selected": "مختار",
      "upgrade.payNow": "ادفع الآن",
      "upgrade.duration": "المدة",
      "upgrade.days": "أيام",
      
      // Auth
      "auth.welcomeBack": "مرحباً بعودتك",
      "auth.loginSubtitle": "سجل دخولك إلى حسابك في فايند أدز",
      "auth.createAccount": "إنشاء حساب",
      "auth.registerSubtitle": "انضم إلى فايند أدز اليوم",
      "auth.login": "تسجيل الدخول",
      "auth.register": "إنشاء حساب",
      "auth.email": "البريد الإلكتروني",
      "auth.emailPlaceholder": "بريدك@الإلكتروني.com",
      "auth.password": "كلمة المرور",
      "auth.fullName": "الاسم الكامل",
      "auth.fullNamePlaceholder": "محمد أحمد",
      "auth.phone": "الهاتف (اختياري)",
      "auth.phoneRequired": "رقم الهاتف",
      "auth.phoneChangeNote": "يمكنك تغيير رمز البلد إذا لزم الأمر",
      "auth.whatsapp": "واتساب (اختياري)",
      "auth.whatsappPlaceholder": "نفس رقم الهاتف أو مختلف",
      "auth.loginButton": "دخول",
      "auth.registerButton": "إنشاء حساب",
      "auth.noAccount": "ليس لديك حساب؟",
      "auth.haveAccount": "لديك حساب؟",
      "auth.loading": "جاري التحميل...",
      "auth.error": "حدث خطأ. يرجى المحاولة مرة أخرى.",
      
      // Favorites
      "favorites.title": "جميع المفضلة",
      "favorites.default": "افتراضي",
      "favorites.savedAds": "إعلان محفوظ",
      "favorites.empty": "لا توجد إعلانات محفوظة",
      "favorites.browse": "تصفح الإعلانات",
      "favorites.personalizedTitle": "قوائم المفضلة المخصصة",
      "favorites.createList": "أنشئ قائمتك المخصصة",
      "favorites.organizeDesc": "نظم مفضلاتك",
      "favorites.inviteDesc": "ادعُ أصدقاءك للمشاهدة أو التعاون في قائمتك",
      "favorites.makeList": "أنشئ قائمة",
      
      // Dashboard
      "dashboard.myAds": "إعلاناتي",
      "dashboard.favorites": "المفضلة",
      "dashboard.messages": "الرسائل",
      "dashboard.profileDesc": "تحديث معلومات ملفك الشخصي العام",
      "dashboard.settingsDesc": "إدارة تفضيلات حسابك والخصوصية",
      
      // Settings
      "settings.emailNotifications": "إشعارات البريد الإلكتروني",
      "settings.pushNotifications": "الإشعارات الفورية",
      "settings.smsNotifications": "إشعارات الرسائل القصيرة",
      "settings.privacy": "الخصوصية",
      "settings.showPhone": "إظهار رقم الهاتف في الإعلانات",
      "settings.showWhatsapp": "إظهار واتساب في الإعلانات",
      "settings.changePassword": "تغيير كلمة المرور",
      "settings.saveSettings": "حفظ الإعدادات",
      
      // Chats
      "chats.title": "المحادثات",
      "chats.select": "اختيار",
      "chats.all": "الكل",
      "chats.buying": "شراء",
      "chats.selling": "بيع",
      "chats.unread": "غير مقروء",
      "chats.verified": "هل أنت موثق؟",
      "chats.verifiedDesc": "احصل على مزيد من الظهور وعزز مصداقيتك.",
      "chats.deactivated": "محادثات معطلة",
      "chats.empty": "محادثاتك فارغة!",
      "chats.emptyDesc": "انشر إعلاناً أو راسل بائعاً لبدء المحادثات",
      "chats.explore": "استكشف",
      "chats.postAd": "انشر إعلان",
      "chats.noMessages": "لا توجد رسائل بعد",
      "chats.typeMessage": "اكتب رسالة...",
      "chats.send": "إرسال",
      "chats.startConversation": "ابدأ المحادثة!",
      
      // Menu
      "menu.getVerified": "احصل على التوثيق",
      "menu.joined": "انضم في",
      "menu.loginRegister": "تسجيل الدخول / إنشاء حساب",
      "menu.myAds": "إعلاناتي",
      "menu.mySearches": "عمليات البحث",
      "menu.profile": "الملف الشخصي",
      "menu.accountSettings": "إعدادات الحساب",
      "menu.notificationSettings": "إعدادات الإشعارات",
      "menu.security": "الأمان",
      "menu.jobApplications": "طلبات التوظيف",
      "menu.carAppointments": "مواعيد السيارات",
      "menu.carInspections": "فحص السيارات",
      "menu.city": "المدينة",
      "menu.allCities": "جميع المدن",
      "menu.language": "اللغة",
      "menu.english": "English",
      "menu.arabic": "العربية",
      "menu.blogs": "المدونة",
      "menu.support": "الدعم",
      "menu.callUs": "اتصل بنا",
      "menu.legalHub": "المركز القانوني",
      "menu.termsOfService": "شروط الخدمة",
      "menu.privacyPolicy": "سياسة الخصوصية",
      "menu.postingRules": "قواعد النشر",
      "menu.safetyTips": "نصائح الأمان",
      "menu.advertising": "الإعلانات",
      "menu.logout": "تسجيل الخروج",
      "menu.version": "النسخة 1.0.0",
      
      // Admin
      "admin.title": "لوحة الإدارة",
      "admin.dashboard": "لوحة التحكم",
      "admin.listings": "الإعلانات",
      "admin.users": "المستخدمين",
      "admin.totalUsers": "إجمالي المستخدمين",
      "admin.totalListings": "إجمالي الإعلانات",
      "admin.activeListings": "الإعلانات النشطة",
      "admin.pendingReview": "بانتظار المراجعة",
      "admin.totalRevenue": "إجمالي الإيرادات",
      "admin.todayActivity": "نشاط اليوم",
      "admin.newUsers": "مستخدمين جدد",
      "admin.newListings": "إعلانات جديدة",
      "admin.approve": "موافقة",
      "admin.reject": "رفض",
      "admin.delete": "حذف",
      "admin.makeAdmin": "جعله مدير",
      "admin.removeAdmin": "إزالة صلاحية الإدارة",
      "admin.admin": "مدير",
      "admin.noListings": "لا توجد إعلانات",
      "admin.noUsers": "لا يوجد مستخدمين",
      "admin.noName": "بدون اسم",
      "admin.accessRequired": "صلاحية المدير مطلوبة",
      "admin.noPermission": "ليس لديك صلاحية الوصول لهذه الصفحة.",
      "admin.goHome": "الذهاب للرئيسية",
      "admin.confirmDelete": "هل أنت متأكد من حذف هذا الإعلان؟",
      "admin.statusFailed": "فشل في تحديث الحالة",
      "admin.deleteFailed": "فشل في حذف الإعلان",
      "admin.toggleAdminFailed": "فشل في تغيير صلاحية الإدارة",
      "admin.active": "نشط",
      "admin.pending": "قيد الانتظار",
      "admin.sold": "مباع",
      "admin.rejected": "مرفوض",
      "admin.flagged": "مشبوه",
      "admin.analytics": "تحليلات",
      
      // Dashboard
      "dashboard.welcome": "مرحباً بعودتك",
      "dashboard.manage": "إدارة إعلاناتك وحسابك",
      "dashboard.postNew": "نشر إعلان جديد",
      "dashboard.totalAds": "إجمالي الإعلانات",
      "dashboard.totalViews": "إجمالي المشاهدات",
      "dashboard.favorites": "المفضلة",
      "dashboard.messages": "الرسائل",
      "dashboard.noAds": "لم تنشر أي إعلان بعد",
      "dashboard.postFirst": "انشر إعلانك الأول",
      "dashboard.noFavorites": "لا توجد مفضلات",
      "dashboard.comingSoon": "قريباً - نظام المراسلة الفورية",
      "dashboard.saveChanges": "حفظ التغييرات",
      "dashboard.saving": "جاري الحفظ...",
      "dashboard.profileUpdated": "تم تحديث الملف الشخصي بنجاح!",
      
      // Edit Listing
      "edit.title": "تعديل الإعلان",
      "edit.photos": "الصور",
      "edit.details": "التفاصيل",
      "edit.contactInfo": "معلومات الاتصال",
      "edit.saveChanges": "حفظ التغييرات",
      "edit.saving": "جاري الحفظ...",
      "edit.uploadingPhotos": "جاري رفع الصور...",
      "edit.newPhoto": "جديد",
      
      // Filters
      "filter.title": "الفلاتر",
      "filter.filters": "الفلاتر",
      "filter.all": "الكل",
      "filter.location": "الموقع",
      "filter.category": "الفئة",
      "filter.price": "السعر",
      "filter.priceMin": "أدنى سعر",
      "filter.priceMax": "أقصى سعر",
      "filter.min": "أدنى",
      "filter.max": "أقصى",
      "filter.condition": "الحالة",
      "filter.apply": "تطبيق الفلاتر",
      "filter.clear": "مسح",
      "filter.clearFilters": "مسح الفلاتر",
      "filter.reset": "إعادة تعيين",
      "filter.results": "نتيجة",
      "filter.sortBy": "ترتيب حسب",
      "filter.newest": "الأحدث أولاً",
      "filter.oldest": "الأقدم أولاً",
      "filter.priceLow": "السعر: من الأقل للأعلى",
      "filter.priceHigh": "السعر: من الأعلى للأقل",
      
      // Search
      "search.resultsFor": "نتائج البحث عن",
      "search.allListings": "جميع الإعلانات",
      "search.adsFound": "إعلان",
      "search.noResults": "لا توجد نتائج",
      
      // Notifications
      "notifications.title": "الإشعارات",
      "notifications.markAllRead": "تحديد الكل كمقروء",
      "notifications.empty": "لا توجد إشعارات",
      "notifications.emptyDesc": "أنت على اطلاع بكل شيء!",
      "notifications.newMessage": "رسالة جديدة",
      "notifications.newFavorite": "حفظ إعلانك",
      "notifications.listingApproved": "تمت الموافقة على إعلانك",
      "notifications.listingRejected": "تم رفض إعلانك",
      "notifications.priceAlert": "انخفاض سعر منتج محفوظ",
      "notifications.viewAll": "عرض الكل",
      "notifications.enablePush": "تفعيل الإشعارات",
      "notifications.pushEnabled": "تم تفعيل الإشعارات",
      "notifications.pushBlocked": "الإشعارات محظورة",
      
      // Common
      "common.aed": "درهم",
      "common.loading": "جاري التحميل...",
      "common.save": "حفظ",
      "common.cancel": "إلغاء",
      "common.search": "بحث",
      "common.viewAll": "عرض الكل",
      "common.contact": "اتصل",
      "common.message": "رسالة",
      "common.copy": "نسخ الرابط",
      "common.copied": "تم نسخ الرابط!",
      "common.error": "خطأ",
      "common.success": "نجاح",
      "common.confirm": "تأكيد",
      "common.yes": "نعم",
      "common.no": "لا",
      "common.ok": "موافق",
      "common.back": "رجوع",
      "common.next": "التالي",
      "common.submit": "إرسال",
      "common.required": "مطلوب",
      "common.optional": "اختياري",
      "common.select": "اختر",
      "common.noResults": "لا توجد نتائج",
      "common.tryAgain": "حاول مرة أخرى",
      "common.guest": "زائر",
      "common.aed": "درهم",
      "common.save": "حفظ التغييرات",
      "common.saving": "جاري الحفظ...",
      "common.saved": "تم حفظ الإعدادات!",
      
      // Errors
      "error.generic": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      "error.network": "خطأ في الشبكة. يرجى التحقق من اتصالك.",
      "error.unauthorized": "يرجى تسجيل الدخول للمتابعة.",
      "error.notFound": "غير موجود",
      "error.invalidCredentials": "بريد إلكتروني أو كلمة مرور غير صحيحة",
      "error.emailExists": "البريد الإلكتروني مسجل مسبقاً",
      "error.requiredFields": "يرجى ملء الحقول المطلوبة",
      "error.selectCategory": "يرجى اختيار فئة",
      "error.uploadFailed": "فشل رفع الصورة",
      "error.deleteFailed": "فشل الحذف",
      "error.updateFailed": "فشل التحديث",
      
      // Success Messages
      "success.adPosted": "تم نشر الإعلان بنجاح!",
      "success.adUpdated": "تم تحديث الإعلان بنجاح!",
      "success.adDeleted": "تم حذف الإعلان بنجاح!",
      "success.profileUpdated": "تم تحديث الملف الشخصي بنجاح!",
      "success.messageSent": "تم إرسال الرسالة!",
      "success.addedToFavorites": "تمت الإضافة للمفضلة",
      "success.removedFromFavorites": "تمت الإزالة من المفضلة",
      
      // UAE Locations
      "location.dubai": "دبي",
      "location.abuDhabi": "أبوظبي",
      "location.sharjah": "الشارقة",
      "location.ajman": "عجمان",
      "location.rasAlKhaimah": "رأس الخيمة",
      "location.fujairah": "الفجيرة",
      "location.ummAlQuwain": "أم القيوين",
      "location.alAin": "العين",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

export default i18n;
